import type { ThemeConfig, WidgetConfig } from "../store/types";

export function buildWebComponentConfigFromAttributes(element: HTMLElement): WidgetConfig {
  const theme: Partial<ThemeConfig> = {};
  const themeAttr = element.getAttribute("theme");
  if (themeAttr) {
    try {
      Object.assign(theme, JSON.parse(themeAttr));
    } catch (e) {
      console.warn("Invalid theme JSON:", themeAttr);
    }
  }

  const themeButtonSize = element.getAttribute("theme-button-size");
  if (themeButtonSize) {
    theme.buttonSize = themeButtonSize;
  }

  return {
    agentId: element.getAttribute("agent-id") || "",
    widgetId: element.getAttribute("widget-id") || undefined,
    avatarUrl: element.getAttribute("avatar-url") || undefined,
    widgetName: element.getAttribute("widget-name") || undefined,
    welcomeMessage: element.getAttribute("welcome-message") || undefined,
    position: (element.getAttribute("position") as any) || "bottom-right",
    debug: element.getAttribute("debug") === "true",
    autoStart: element.getAttribute("auto-start") === "true",
    mode: (element.getAttribute("mode") as any) || "voice",
    uiVariant: (element.getAttribute("ui-variant") as any) || undefined,
    language: (element.getAttribute("language") as any) || "de",
    gpsEnabled: element.getAttribute("gps-enabled") === "true",
    ...(Object.keys(theme).length > 0 ? { theme } : {}),
  };
}
